import React, { Component } from 'react';
import axios from 'axios';
import Helmet from 'react-helmet';

const initialState = {
  otpAddressFlg: '0',
  email: '',
  phonenumber: '',
  complete: false,
  errorMap: null,
  loading: false,
  regOtpAddressFlg: '0',
  changeBtnState: true
}

class OtpChange extends Component {
  state = initialState;

  componentDidMount() {

    // GA計測用データレイヤースクリプトを追加する
    window.addDataLayerScript('jmbauth_otp_change_notification');

    // 画面表示処理
    this.drawing();
  }

  drawing = () => {
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    if (!this.state.complete) {
      let result;
      let flag = true;

      // 属性情報取得要求を行う
      try {

        // ローディング開始
        this.setState({ loading: true });

        // 属性情報取得API
        result = axios
          .get(process.env.REACT_APP_URL_CO_SC_API_ATTRIBUTES,
            {
              headers: {
                'accept-language': window.changeLang(sessionStorage.getItem("lang")),
                'Cache-Control': 'no-store',
                'Pragma': 'no-cache'
              }
            }
          )
          .then(response => {
            this.setState({
              errorMap: null, loading: false, otpAddressFlg: response.data.otpAddressFlg,
              email: response.data.email, phonenumber: response.data.phonenumber, regOtpAddressFlg: response.data.otpAddressFlg
            });

          })
          .catch(error => {
            if (error.response) {
              if (error.response.status === 400) {
                this.setState({
                  errorMap:
                    { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.otpChange.M022_errorMessage001 },
                  loading: false,
                  otpAddressFlg: '0',
                  email: '',
                  phonenumber: '',
                  regOtpAddressFlg: '0'
                });
                // エラーメッセージ表示領域に遷移する
                window.location = "#JS_error";
              }
              else if (error.response.status === 401) {
                this.setState({
                  errorMap:
                    { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.otpChange.M022_errorMessage001 },
                  loading: false,
                  otpAddressFlg: '0',
                  email: '',
                  phonenumber: '',
                  regOtpAddressFlg: '0'
                });
                // エラーメッセージ表示領域に遷移する
                window.location = "#JS_error";
              }
              else if (error.response.status === 500) {

                // エラー画面に遷移し、処理を終了する
                flag = false;
                this.props.history.push({
                  pathname: `${process.env.REACT_APP_CONTEXT_PATH}/error`
                });
              }
              else {
                this.setState({
                  errorMap:
                    { ERROR: messageList.otpChange.M022_errorMessage001 },
                  loading: false,
                  otpAddressFlg: '0',
                  email: '',
                  phonenumber: '',
                  regOtpAddressFlg: '0'
                });
                // エラーメッセージ表示領域に遷移する
                window.location = "#JS_error";
              }
            }
            else {
              this.setState({
                errorMap:
                  { ERROR: messageList.otpChange.M022_errorMessage001 },
                loading: false,
                otpAddressFlg: '0',
                email: '',
                phonenumber: '',
                regOtpAddressFlg: '0'
              });
              // エラーメッセージ表示領域に遷移する
              window.location = "#JS_error";
            }
          });

      } catch (err) {
        console.error(err);
        this.setState({
          errorMap:
            { ERROR: messageList.otpChange.M022_errorMessage001 },
          loading: false,
          otpAddressFlg: '0',
          email: '',
          phonenumber: '',
          regOtpAddressFlg: '0'
        });
        // エラーメッセージ表示領域に遷移する
        window.location = "#JS_error";

      } finally {
        Promise.race([result]).finally(()=>{
          if(flag){
            // セッションストレージに登録済みOTP通知用携帯電話番号を設定する
            sessionStorage.setItem('OTPMOBILENUMBER', this.state.phonenumber);

            // 通知先ラジオボタンの初期値を設定する
            if (this.state.regOtpAddressFlg === '0') {
              document.getElementById('LA-input-mail').checked = true;
            } else {
              document.getElementById('LA-input-tel').checked = true;
            }

            // メールアドレス表示
            document.getElementById('WA_address-1').innerHTML = (this.state.email === '' ? messageList.otpChange.M024_register : this.state.email);

            if (this.state.email !== '' && this.state.phonenumber !== '') {
              this.setState({changeBtnState : false});
            }
          }
        });
      }

    }

  }

  // OTP通知先変更画面[変更する]ボタン押下処理
  otpNoticesSetting = async () => {

    // Cookieからl_sidを取得する
    let l_sid = window.getCookieValue('l_sid');
    // アクショントークン格納変数の宣言
    let actionToken = null;

    // SDK呼出(アクションレポート)
    try{
      // アクションのレポート作成
      const actionPromise = window.tsPlatform.drs.triggerActionEvent("account_details_change_otpauth", { correlationId: l_sid });

      // タイムアウト判定関数
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error('Action token request timed out'));
        }, process.env.REACT_APP_TRIGGERACTIONEVENT_TIMEOUT); // envに設定されたタイムアウト時間(ミリ秒)を設定
      });

      // タイムアウト時間内にアクショントークンが取得できた場合、アクショントークン変数に設定
      const actionResponse = await Promise.race([actionPromise, timeoutPromise]);
      actionToken = actionResponse ? actionResponse.actionToken : null;
    }catch(e){
      // タイムアウト時の処理
      if (e.message.includes('timed out')) {
        // エラー文言を、アクショントークン変数に設定
        actionToken = 'jallogin_transmit_api_timeout';
      }
    }

    const { otpAddressFlg, regOtpAddressFlg } = this.state;

    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    // バリデーションチェックを行う
    if (regOtpAddressFlg === otpAddressFlg) {
      this.setState({ errorMap: { ERROR: messageList.otpChange.M023_errorMessage002 } });
      // エラーメッセージ表示領域に遷移する
      window.location = "#JS_error";
      // 処理を終了する。
      return;
    }

    // 属性情報更新要求を行う
    try {

      // ローディング開始
      this.setState({ loading: true });

      // 属性情報更新API
      axios.put(process.env.REACT_APP_URL_CO_SC_API_ATTRIBUTES_UPDATE,
        {
          attributes : {
           otpAddressFlg : otpAddressFlg
          }
        },
        {
          headers: {
            'accept-language': window.changeLang(sessionStorage.getItem("lang")),
            'Cache-Control': 'no-store',
            'Pragma': 'no-cache'
          }
        }
      )
        .then(response => {

          this.setState({ errorMap: null, complete: true, loading: false });
          // GA計測用データレイヤースクリプトを追加する
          window.addDataLayerScript('jmbauth_otp_change_notification_completion');

          // 画面表示処理
          this.drawing();
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status === 400) {
              this.setState({
                errorMap:
                  { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.otpChange.M022_errorMessage001 },
                loading: false
              });
              // エラーメッセージ表示領域に遷移する
              window.location = "#JS_error";
            }
            else if (error.response.status === 401) {
              this.setState({
                errorMap:
                  { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.otpChange.M022_errorMessage001 },
                loading: false
              });
              // エラーメッセージ表示領域に遷移する
              window.location = "#JS_error";
            }
            else if (error.response.status === 500) {

              // エラー画面に遷移し、処理を終了する
              this.props.history.push({
                pathname: `${process.env.REACT_APP_CONTEXT_PATH}/error`
              });
            }
            else {
              this.setState({
                errorMap:
                  { ERROR: messageList.otpChange.M022_errorMessage001 },
                loading: false
              });
              // エラーメッセージ表示領域に遷移する
              window.location = "#JS_error";
            }
          }
          else {
            this.setState({
              errorMap:
                { ERROR: messageList.otpChange.M022_errorMessage001 },
              loading: false
            });
            // エラーメッセージ表示領域に遷移する
            window.location = "#JS_error";
          }
        });

    } catch (err) {
      console.error(err);
      this.setState({
        errorMap:
          { ERROR: messageList.otpChange.M022_errorMessage001 },
        loading: false
      });
      // エラーメッセージ表示領域に遷移する
      window.location = "#JS_error";

    } finally {
    }
  }

  // OTP通知先変更画面へ戻る処理
  beforeOtpChange = () => {
    // 完了フラグ設定
    this.setState({ complete: false, changeBtnState: true }, () => {

      // 画面表示処理
      this.drawing();
    })
  }

  // 画面をクローズする
  close = e => {
    window.open('about:blank', '_self').close();
  }

  radioChange = e => {
    this.setState({ otpAddressFlg: e.currentTarget.value });
  }

  render() {

    // 文言リストを取得する
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    // OTP通知先変更完了画面表示
    if (this.state.complete) {
      return (
        <section className="content">
          <Helmet
            title={messageList.otpChangeCompletion.M001_browserTitle} >
          </Helmet>

          {/* 画面タイトル表示部 */}
          <div className="ds-heading ds-heading--lg">
            <h1 className="ds-heading__title">{messageList.otpChangeCompletion.M002_pageTitle}</h1>
          </div>

          {/* 操作ボタン表示部 */}
          <div className="contentInner">
            <div className="buttonLayout">
              <div className="buttonWrap buttonWrap--center">
                <div className="ds-button ds-button--tertiary ds-button--large">
                  <button className="ds-button__trigger" type="button" onClick={this.beforeOtpChange}>
                    <span className="ds-button__label">{messageList.otpChangeCompletion.M003_back}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

        </section>
      );
    }

    // OTP通知先変更画面表示
    else {

      // デザイン定義ファイルを読み込み
      let designJson = require('../jsonFile/design.json');
      let designFile;

      // 電話番号の登録要否に応じて、デザインを切り替える
      if(this.state.phonenumber === ''){
        designFile = require('./design/' + designJson.otpChange.I01['default']);
      }else{
        designFile = require('./design/' + designJson.otpChange.I02['default']);
      }

      return (
        <section className="content">
          <Helmet
            title={messageList.otpChange.M001_browserTitle} >
          </Helmet>

          { // Loadingモーダル表示
            this.state.loading &&
            <div id="loading" className="loading-modal"><img className="loading-img" src={`${process.env.PUBLIC_URL}/assets/img/load.gif`} alt="loading" /></div>
          }

          {/* 画面タイトル表示部 */}
          <div className="ds-heading ds-heading--lg">
            <h1 id="WA_address_title" className="ds-heading__title">{messageList.otpChange.M002_pageTitle}</h1>
          </div>

          <div className="contentInner">
            {/* サブタイトル表示部 */}
            <div className="ds-heading ds-heading--sm">
              <h2 className="ds-heading__title">{messageList.otpChange.M003_pageTitleSub}</h2>
            </div>

            <p className="ds-text">{messageList.otpChange.M004_guideMessage001}</p>

            <div id="JS_error">
              { // エラーメッセージ表示
                (this.state.errorMap && this.state.errorMap.ERROR) &&
                <div className="ds-inlineNote ds-inlineNote--attention u-mt-24 u-mb-24" role="alert" aria-live="assertive">
                  <div className="ds-inlineNote__details">
                    <div className="ds-inlineNote__summary">
                      <h2 className="ds-inlineNote__heading">
                        <span className="ds-inlineNote__headingIcon">
                          <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.otpChange.M005_errorIconText}>
                            <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                          </svg>
                        </span>
                        <span className="ds-inlineNote__headingLabel">{messageList.otpChange.M006_errorBoxTitle}</span>
                      </h2>
                    </div>
                    <div className="ds-inlineNote__content">
                      <p className="ds-text">{this.state.errorMap.ERROR}</p>
                    </div>
                  </div>
                </div>/* /ds-inlineNote */
              }
            </div>

            <form name="form">
              <fieldset className="listOnetimePass" aria-labelledby="WA_address_title">

                {/* メールアドレス選択 */}
                <div className="listOnetimePass__item">
                  <div className="listOnetimePass__radio">
                    <label className="ds-radio">
                      <input className="ds-radio__input" type="radio" name="address" id="LA-input-mail" aria-describedby="WA_address-1 WA_address-text-1" value='0' onClick={this.radioChange} />
                      <span className="ds-radio__partsWrap">
                        <span className="ds-radio__parts" role="none"></span>
                        <span className="ds-radio__text">{messageList.otpChange.M008_otpNoticesMailaddress}</span>
                      </span>
                    </label>
                  </div>
                  <div className="listOnetimePass__detail">
                    <div id="WA_address-1" className="listOnetimePass__address"></div>
                    <p id="WA_address-text-1" className="ds-text listOnetimePass__text">
                      {messageList.otpChange.M009_mailaddressChangeText001}<br />
                      {messageList.otpChange.M010_mailaddressChangeText002}
                    </p>
                    {/* PC用メールアドレス変更リンク */}
                    <div className="ds-button ds-button--tertiary ds-button--small u-d-none--sp">
                      <a className="ds-button__trigger" href="https://www121.jal.co.jp/JmbWeb/JR/EmailChgBasicPre_ja.do" target="_blank" rel="noopener noreferrer" aria-describedby="WA_address-1">
                        <span className="ds-button__label">{messageList.otpChange.M011_mailaddressChangeText003}</span>
                        <span className="ds-button__icon ds-button__icon--right">
                          <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageList.otpChange.M012_newWindowIcon}>
                            <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                          </svg>
                        </span>
                      </a>
                    </div>
                    {/* SP用メールアドレス変更リンク */}
                    <div className="ds-button ds-button--tertiary ds-button--small u-d-none--pc">
                      <a className="ds-button__trigger" href="https://sp5971.jal.co.jp/JmbSp/JR/EmailChgPcPre_ja.do" target="_blank" rel="noopener noreferrer" aria-describedby="WA_address-1">
                        <span className="ds-button__label">{messageList.otpChange.M011_mailaddressChangeText003}</span>
                        <span className="ds-button__icon ds-button__icon--right">
                          <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageList.otpChange.M012_newWindowIcon}>
                            <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
                          </svg>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>

                {/* 携帯電話（SMS）選択（デザインファイルに委譲） */}
                {(designFile) && designFile.getDesign(this.state, this.radioChange, messageList.otpChange)}

              </fieldset>

              {/* ボタン表示部 */}
              <div className="buttonLayout">
                <div className="buttonWrap buttonWrap--center">
                  {(this.state.changeBtnState === false) ?
                    <div className="ds-button ds-button--primary ds-button--large">
                      <button className="ds-button__trigger" type="button" formNoValidate onClick={this.otpNoticesSetting} id="otpUpdate">
                        <span className="ds-button__label">{messageList.otpChange.M018_update}</span>
                      </button>
                    </div>
                    :
                    <div className="ds-button ds-button--primary ds-button--large is-disabled">
                      <button className="ds-button__trigger ds-button__trigger--disabled" type="button" disabled formNoValidate id="otpUpdate">
                        <span className="ds-button__label">{messageList.otpChange.M018_update}</span>
                      </button>
                    </div>
                  }
                </div>
                <div className="buttonWrap buttonWrap--left">
                  <div className="ds-button ds-button--tertiary ds-button--large">
                    <button className="ds-button__trigger" type="button" onClick={this.close}>
                      <span className="ds-button__label">{messageList.otpChange.M019_back}</span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>

          {/* 案内表示部 */}
          <div className="contentInner">
            <div className="ds-heading ds-heading--sm">
              <h2 className="ds-heading__title">{messageList.otpChange.M020_notices}</h2>
            </div>
            <ul className="ds-listText ds-listText--md">
              <li className="ds-listText__item">{messageList.otpChange.M021_notice001}</li>
              <li className="ds-listText__item">{messageList.otpChange.M021_notice002}</li>
              <li className="ds-listText__item">{messageList.otpChange.M021_notice003}</li>
            </ul>
          </div>

        </section>
      );
    }
  }
}

export default OtpChange
